
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/[slug]/[childSlug]",
      function () {
        return require("private-next-pages/shop/[slug]/[childSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/[slug]/[childSlug]"])
      });
    }
  